import React from 'react';

interface LoadingSpinnerProps {
  message?: string;
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

const LoadingSpinnerComponent: React.FC<LoadingSpinnerProps> = ({ message, className, size = 'md' }) => {
  // Size mappings
  const sizeClasses = {
    xs: 'h-3 w-3',
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  };

  const paddingClasses = {
    xs: '',
    sm: 'p-1',
    md: 'p-8',
    lg: 'p-8'
  };

  // If className is provided, use it directly for custom styling
  if (className) {
    return <div className={`animate-spin rounded-full border-b-2 ${className}`}></div>;
  }

  // Default behavior with size presets
  return (
    <div className={`flex flex-col items-center justify-center ${paddingClasses[size]}`}>
      <div className={`animate-spin rounded-full ${sizeClasses[size]} border-b-2 border-blue-500`}></div>
      {message && (
        <p className="mt-4 text-gray-600 text-sm animate-pulse">{message}</p>
      )}
    </div>
  );
};

/**
 * Memoized LoadingSpinner component to prevent unnecessary re-renders
 */
const LoadingSpinner = React.memo(LoadingSpinnerComponent);

export default LoadingSpinner;